import { render, staticRenderFns } from "./join-event.vue?vue&type=template&id=4675efef"
import script from "./join-event.vue?vue&type=script&lang=js"
export * from "./join-event.vue?vue&type=script&lang=js"
import style0 from "./join-event.vue?vue&type=style&index=0&id=4675efef&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports